import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import defaultRouters from './defaultRouters';

NProgress.configure({ showSpinner: false });

// 消除重复进入相同路由的警报
// push方式
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// replace方式
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes: defaultRouters
});

// 路由拦截 token校验 权限相关
router.beforeEach(async (to, from, next) => {
  NProgress.start();

  if (store.getters.adminInfo.customer) {
    if (to.name === 'register') {
      next('/login');
    }
    // 登录页直接进入
    if (to.name === 'login') {
      next();
    } else {
      // 获取当前用户token
      let token = localStorage.getItem('token');
      if (token) {
        // 判断是否已生成过权限路由
        if (store.getters.routes.length) {
          next();
        } else {
          // 获取用户信息
          await store.dispatch('user/getUserInfo');
          // 生成权限路由
          await store.dispatch('permission/generateRoutes');
          next({
            path: to.path,
            query: to.query,
            replace: true
          });
        }
      } else {
        store.commit('user/signOut', to.path);
      }
    }
  } else {
    // 获取管理员信息
    await store.dispatch('user/getSystemCustomerInfo');
    if (store.getters.adminInfo.customer) {
      if (to.name === 'register') {
        next('/login');
      } else {
        next({
          path: to.path,
          query: to.query,
          replace: true
        });
      }
    } else {
      if (to.name === 'register') {
        next();
      } else {
        next('/register');
      }
    }
  }
});

router.afterEach((to, from, next) => {
  NProgress.done();

  // 处理页头尾部添加的文字
  if (store.getters.pageHeaderAppendText) {
    store.commit('common/setPageHeaderAppendText', '');
  }
});

export default router;
